<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">            
      <!------------------------search---------------------->
      <div style="float:left;width:96%;padding:2% 2% 3% 2%;border-radius:6px;background:#fff;border:1px solid #DCDFE6;">
	      <el-form :inline="true" class="demo-form-inline" size="small">
	      	  <el-form-item>
				  <span>今日销售</span>&nbsp;&nbsp;
	          </el-form-item>
	          <el-form-item>
				  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
	          </el-form-item>
	          <el-form-item>
	            <el-button type="primary" icon="el-icon-search" @click="getReport">查询</el-button>
	          </el-form-item>
	      </el-form>
	      <el-col :span="24" v-loading="salesLoading">
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>今日销售额：</h5><h2>{{sales.salescount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>今日产品成本：</h5><h2>{{sales.costcount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>今日毛利：</h5><h2>{{sales.profit|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>今日退款：</h5><h2>{{sales.refundcount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>今日快递费：</h5><h2>{{sales.expressamount|yen}}</h2></div></el-col>
	      </el-col>
      </div>
      <!------------------------search end---------------------->
      
      
      <!------------------------search---------------------->
      <div style="float:left;width:96%;padding:2% 2% 3% 2%;border-radius:6px;background:#fff;border:1px solid #DCDFE6;margin-top:2%">
	      <el-col :span="24"></el-col>
	      <el-form :inline="true" class="demo-form-inline" size="small">
	      	  <el-form-item>
				  <span>本月销售</span>&nbsp;&nbsp;
	          </el-form-item>
	          <el-form-item>
				  <el-date-picker v-model="querymonth.date" type="month" placeholder="请选择月份" value-format="yyyy-MM"></el-date-picker>
	          </el-form-item>
	          <el-form-item>
	            <el-button type="primary" icon="el-icon-search" @click="getmonthReport">查询</el-button>
	          </el-form-item>
	      </el-form>
	      <el-col :span="24" v-loading="monthsalesLoading">
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月销售额：</h5><h2>{{monthsales.salescount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月产品成本：</h5><h2>{{monthsales.costcount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月毛利：</h5><h2>{{monthsales.profit|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月退款：</h5><h2>{{monthsales.refundcount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月未结账款：</h5><h2>{{monthsales.profitrate|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>剩余库存总金额：</h5><h2>{{monthsales.lastamount|yen}}</h2></div></el-col>
	        <el-col :span="1">&nbsp;</el-col>
	        <el-col :span="5"><div class="report-box" style="background:#fff;margin-bottom:20px"><h5>本月快递费总金额：</h5><h2>{{monthsales.expressamount|yen}}</h2></div></el-col>
	      </el-col>
      </div>
      
      <div style="float:left;width:96%;padding:2% 2% 3% 2%;border-radius:6px;background:#fff;border:1px solid #DCDFE6;margin-top:2%">
	      <el-col>
			  <el-date-picker size="small" v-model="querybrand.date" type="month" placeholder="请选择月份" value-format="yyyy-MM"></el-date-picker>
	      	  <el-button size="small" type="primary" icon="el-icon-search" @click="getBrand">查询</el-button>
	      </el-col>
	      <el-col :span="24">
		      <div class="brand">
		          <IEcharts :option="brand" :loading="brandloading"/>
		      </div>
	      </el-col>
	      <el-col :span="24">
	          <el-col :span="12">
		          <div class="account">
		              <IEcharts :option="account" :loading="accountloading"/>
		          </div>
	          </el-col>
	          <el-col :span="12">
		          <div class="account">
		              <IEcharts :option="category" :loading="categoryloading"/>
		          </div>
	          </el-col>
	      </el-col>
      </div>
      <!------------------------search end---------------------->
    
  </div>
  </transition>   
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Report/index",
      transitionshow:true,
      sales:[],
      salesLoading:false,
      query:{
        act:'sales',
        token:this.$cookies.get('token'),
        date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()]
      },
      
      monthsalesLoading:false,
      monthsales:[],
      querymonth:{
        act:'monthsales',
        token:this.$cookies.get('token'),
        date:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1)
      },
      
      querybrand:{
        act:'brand',
        token:this.$cookies.get('token'),
        date:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1)
      },
      
      queryaccount:{
        act:'account',
        token:this.$cookies.get('token'),
        date:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1)
      },
      
      querycategory:{
        act:'category',
        token:this.$cookies.get('token'),
        date:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1)
      },
      
      brandloading: false,
      accountloading: false,
      categoryloading: false,
      brand: {
          title: {
          	  text: '本月品牌营业额统计',
          	  textStyle: {       
              	  fontSize:15,  
              }
          },
      	  tooltip: {},
	      grid: {
	      	  left: '1%',
	          right: '1%',
	          bottom: '3%',
	          containLabel: true
	      },
      	  xAxis: {data: []},
      	  yAxis: {},
	      series: [{
	          name: '营业额',
	          type: 'bar',
	          data: [],
	          itemStyle:{ 
				  normal:{color:'#409EFF'} //柱状颜色
			  },
	      }],
      },
      
      account: {
          title: {
          	  text: '支付方式统计',
          	  textStyle: {       
              	  fontSize:15,  
              }
          },
          tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
              orient: 'vertical',
              left: 'left',
              data: []
          },
          series : [{
              name: '访问来源',
              type: 'pie',
              radius : '70%',
              center: ['50%', '50%'],
              data:[],
              itemStyle: {
              	 emphasis: {
                     shadowBlur: 10,
                     shadowOffsetX: 0,
                     shadowColor: 'rgba(0, 0, 0, 0.5)'
                 }
              }
          }]
      },
      
      category: {
        title: {
            text: '按分类统计',
            textStyle: {       
                fontSize:15,  
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            data: []
        },
        series : [
            {
                name: '访问来源',
                type: 'pie',
                radius : '70%',
                center: ['50%', '50%'],
                data:[],
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
      }
    }
  },
  filters: {
    yen: function (value) {
      return '¥ '+value
    }
  },
  components: {
    IEcharts
  },
  mounted(){
    this.getReport();
    this.getmonthReport();
    this.getBrand();
    this.getAccount();
  },
  methods:{
  
    /** 今日销售信息 **/
    getReport(){
      this.salesLoading=true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.salesLoading=false;
          this.$message.error(res.data.Message);
        }else{
          this.sales = JSON.parse(Base64.decode(res.data.Data));
          this.salesLoading=false;
        }
      }).catch((res) => {
          this.salesLoading=false;
          this.$message.error(this.GLOBAL.errortext);
      });
      //this.getBrand();
      //this.getAccount();
      this.getCategory();
    },
    
    
    /** 本月销售信息 **/
    getmonthReport() {
        this.monthsalesLoading=true;
      	var resource = this.$resource(this.url);
      	resource.query(this.querymonth).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.monthsalesLoading=false;
	          this.$message.error(res.data.Message);
	        }else{
	          this.monthsales = JSON.parse(Base64.decode(res.data.Data));
	          this.monthsalesLoading=false;
	        }
        }).catch((res) => {
          this.monthsalesLoading=false;
          this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 品牌营业额信息 **/
    getBrand(){
    	this.brandloading=true;
    	this.accountloading=true;
    	this.categoryloading=true;
    	this.queryaccount.date=this.querybrand.date;
    	this.querycategory.date=this.querybrand.date;
    	
        var resource = this.$resource(this.url);
        resource.query(this.querybrand).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.brandloading=false;
	        }else{
	            var info = JSON.parse(Base64.decode(res.data.Data));	            
	            this.brand.series[0].data = info.brandcount;
	            this.brand.xAxis.data = info.brandname;
	            this.brandloading=false;
	        }
        }).catch((res) => {
            //this.brandloading=false;
        });
        
        this.getAccount();
	    this.getCategory();
    },
    
    
    /** 支付方式销售额统计 **/
    getAccount(){
    	this.account.series[0].data=[];
        var resource = this.$resource(this.url);
        resource.query(this.queryaccount).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.accountloading=false;
	        }else{
	        	var data = res.data.Data;        
	            var info = JSON.parse(Base64.decode(res.data.Data));
	            if(data!='' && data!=null) this.account.series[0].data = info; 
	            this.accountloading=false;     
	        }
        }).catch((res) => {
			this.accountloading=false;
        });
    },
    
    
    /** 按分类统计 **/
    getCategory(){
    	this.category.series[0].data=[];
        var resource = this.$resource(this.url);
        resource.query(this.querycategory).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.categoryloading=false;
	        }else{
	            var info = JSON.parse(Base64.decode(res.data.Data));
	            if(info!='' && info!=null) this.category.series[0].data = info;
	            this.categoryloading=false;
	        }
        }).catch((res) => {
            this.categoryloading=false;
        });
    }
  }
}
</script>
<style>
.report-box{border:1px solid #DCDFE6;border-radius:5px;padding-left:25px;box-shadow:0 5px 10px #ddd;}
.report-box h5{color:#666;font-weight:100;}
.report-box h2{font-size:20px;color:#E6A23C}
.brand{width:100%;height:400px;margin-top:30px;}
.account{width:100%;height:400px;margin-top:50px;}
</style>


// WEBPACK FOOTER //
// src/components/stat/Report.vue